/* __next_internal_client_entry_do_not_use__ SDUIGridV2ExpandButton auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@faire/web--source/slate/Button";
import { Arrow } from "@faire/web--source/slate/icons/foundation/Arrow";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
// eslint-disable-next-line no-restricted-imports
import { assignInlineVars } from "@vanilla-extract/dynamic";
import React from "react";
import { SDUIOnClickHandler } from "@faire/retailer/components/SDUI/__internal__/SDUIOnClickHandler/SDUIOnClickHandler";
import { getSlateButtonVariant } from "@faire/retailer/components/SDUI/ComponentRenderers/Button/getSlateButtonVariant";
import { useNumHiddenTiles } from "./useNumHiddenTiles";
import { getGridExpandButtonResponsiveStyleVars } from "./v2AutoLayoutStylingUtils";
import * as gridV2Styles from "./v2Styles.css";
export var SDUIGridV2ExpandButton = function(param) {
    var isExpanded = param.isExpanded, truncationBehaviour = param.truncationBehaviour, numTiles = param.numTiles, containerRef = param.containerRef, tileRef = param.tileRef, columnSpacingPixels = param.columnSpacingPixels, onClick = param.onClick, loggingEventParams = param.loggingEventParams;
    var _deviceTruncationBehaviour_expand, _deviceTruncationBehaviour_expand1;
    var deviceTruncationBehaviour = useResponsiveValue(truncationBehaviour);
    var numHiddenTiles = useNumHiddenTiles(containerRef, tileRef, columnSpacingPixels, numTiles);
    if (isExpanded || numHiddenTiles === 0 || !deviceTruncationBehaviour.expand) {
        return null;
    }
    var _deviceTruncationBehaviour_expand_on_click;
    var onClickActions = (_deviceTruncationBehaviour_expand_on_click = (_deviceTruncationBehaviour_expand = deviceTruncationBehaviour.expand) === null || _deviceTruncationBehaviour_expand === void 0 ? void 0 : _deviceTruncationBehaviour_expand.on_click) !== null && _deviceTruncationBehaviour_expand_on_click !== void 0 ? _deviceTruncationBehaviour_expand_on_click : [];
    var buttonVariant = getSlateButtonVariant((_deviceTruncationBehaviour_expand1 = deviceTruncationBehaviour.expand) === null || _deviceTruncationBehaviour_expand1 === void 0 ? void 0 : _deviceTruncationBehaviour_expand1.variant);
    return /*#__PURE__*/ _jsx(SDUIOnClickHandler, {
        className: gridV2Styles.expandButtonStyle,
        // use CSS to hide this so visibility is consistent in SSR
        componentStyle: assignInlineVars(getGridExpandButtonResponsiveStyleVars(truncationBehaviour, isExpanded)),
        onClickActions: onClickActions,
        loggingData: loggingEventParams,
        children: /*#__PURE__*/ _jsxs(Button, {
            variant: buttonVariant,
            onClick: onClick,
            children: [
                numHiddenTiles === undefined ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "q6iBaD",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Show more"
                        }
                    ]
                }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "4cwiCv",
                    defaultMessage: [
                        {
                            type: 6,
                            value: "tileNumber",
                            options: {
                                one: {
                                    value: [
                                        {
                                            type: 0,
                                            value: "Show "
                                        },
                                        {
                                            type: 7
                                        },
                                        {
                                            type: 0,
                                            value: " more"
                                        }
                                    ]
                                },
                                other: {
                                    value: [
                                        {
                                            type: 0,
                                            value: "Show "
                                        },
                                        {
                                            type: 7
                                        },
                                        {
                                            type: 0,
                                            value: " more"
                                        }
                                    ]
                                }
                            },
                            offset: 0,
                            pluralType: "cardinal"
                        }
                    ],
                    values: {
                        tileNumber: numHiddenTiles
                    }
                }),
                /*#__PURE__*/ _jsx(Arrow, {
                    direction: "down",
                    width: "16px",
                    height: "16px"
                })
            ]
        })
    });
};
